export interface IDestinationsState {
    destinations: any[];
    selectedDestination: any;
  }
  
  export const initialDestinationsState: IDestinationsState = {
    destinations: [],
    selectedDestination: null
  };